module.exports = __webpack_public_path__ + "img/mbank.001d5ce4.svg";